const baseIconSize = {
  scaledSize: new google.maps.Size(31.75, 40),
  origin: new google.maps.Point(0, 0),
  labelOrigin: new google.maps.Point(16, 16),
  anchor: new google.maps.Point(0, 40),
};

export const massiveConstants = {
  selectZoom: 16,
  clusterMaxZoom: 15,
  normalZIndex: 100,
  cediZIndex: 101,
  selectedZIndex: 200,
  normalIcon: {
    url: '/assets/images/icons/markers/marker-extra.png',
    ...baseIconSize,
  },
  selectedIcon: {
    url: '/assets/images/icons/markers/marker-extra-active.png',
    ...baseIconSize,
  },
};
